// src/components/SensorForm.js
import React, { useState, useEffect } from 'react';
import { Box, Button, Input, Select, FormControl, FormLabel, useToast } from '@chakra-ui/react';
import { addSensor, getGateways } from '../utils/firebase.utils';

const SensorForm = ({ sensor, onSubmit }) => {
  const [formData, setFormData] = useState({
    id: sensor ? sensor.id : `sensor-${Date.now()}`,
    name: sensor ? sensor.name : '',
    type: sensor ? sensor.type : 'Dragino LHT65',
    gatewayId: sensor ? sensor.gatewayId : '',
    status: sensor ? sensor.status : 'Active',
  });
  const [gateways, setGateways] = useState([]);
  const toast = useToast();

  useEffect(() => {
    const fetchGateways = async () => {
      const gatewaysList = await getGateways();
      setGateways(gatewaysList);
    };
    fetchGateways();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addSensor(formData);
      toast({
        title: "Sensor saved.",
        description: "The sensor has been successfully saved.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      onSubmit();
    } catch (error) {
      toast({
        title: "Error saving sensor.",
        description: "There was an error saving the sensor. Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box as="form" onSubmit={handleSubmit} p={4}>
      <FormControl mb={3}>
        <FormLabel>Sensor Name</FormLabel>
        <Input name="name" value={formData.name} onChange={handleChange} required />
      </FormControl>
      <FormControl mb={3}>
        <FormLabel>Sensor Type</FormLabel>
        <Select name="type" value={formData.type} onChange={handleChange}>
          <option value="Dragino LHT65">Dragino LHT65</option>
          {/* Add more sensor types as needed */}
        </Select>
      </FormControl>
      <FormControl mb={3}>
        <FormLabel>Gateway</FormLabel>
        <Select name="gatewayId" value={formData.gatewayId} onChange={handleChange} required>
          {gateways.map(gateway => (
            <option key={gateway.id} value={gateway.id}>{gateway.name}</option>
          ))}
        </Select>
      </FormControl>
      <FormControl mb={3}>
        <FormLabel>Status</FormLabel>
        <Select name="status" value={formData.status} onChange={handleChange}>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </Select>
      </FormControl>
      <Button type="submit" colorScheme="teal">Save Sensor</Button>
    </Box>
  );
};

export default SensorForm;